import { render, staticRenderFns } from "./DodajKontroleIP.vue?vue&type=template&id=8ede4a94&"
import script from "./DodajKontroleIP.vue?vue&type=script&lang=js&"
export * from "./DodajKontroleIP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports